"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateToLatestVersion = void 0;
var lodash_1 = require("lodash");
var versions_1 = require("@wix/wix-vod-constants/dist/app-settings/versions");
var version_1_1 = require("./migrations/version-1");
var version_2_1 = require("./migrations/version-2");
var version_3_1 = require("./migrations/version-3");
var version_4_1 = require("./migrations/version-4");
var migrations = (_a = {},
    _a[versions_1.APP_SETTINGS_VERSION_0] = version_1_1.migrateToV1,
    _a[versions_1.APP_SETTINGS_VERSION_1] = version_2_1.migrateToV2,
    _a[versions_1.APP_SETTINGS_VERSION_2] = version_3_1.migrateToV3,
    _a[versions_1.APP_SETTINGS_VERSION_3] = version_4_1.migrateToV4,
    _a);
function migrateToLatestVersion(appSettings) {
    var version = (0, lodash_1.get)(appSettings, 'numbers.settingsVersion', versions_1.APP_SETTINGS_VERSION_0);
    for (var v = version; v < versions_1.APP_SETTINGS_VERSION_LATEST; v++) {
        appSettings = migrations[v](appSettings);
    }
    return appSettings;
}
exports.migrateToLatestVersion = migrateToLatestVersion;
//# sourceMappingURL=migration.js.map